import { graphql } from 'gatsby';
import React from 'react';
import OrderJourneyBannerCarousel from './OrderJourneyBannerCarousel';

const ModularBannerCarousel = ({ data }) => {
  const { backgroundColour, text, noScroll } = data;

  return (
    <OrderJourneyBannerCarousel
      backgroundColor={backgroundColour}
      content={text}
      isModular={true}
      noScroll={noScroll}
    />
  );
};

export default ModularBannerCarousel;

export const fragment = graphql`
  fragment ModularBannerCarousel on DatoCmsBannerCarousel {
    internal {
      type
    }
    backgroundColour
    noScroll
    text {
      ... on DatoCmsTextBlock {
        id
        text {
          value
        }
      }
    }
  }
`;
